import React from "react";

import {queries} from "shared/api/queries";
import {useTranslation} from "react-i18next";
import 'features/shipping/components/screen/shippingScreen.css';
import {Checkbox} from "shared/ui";
import {SellerBatchType, ShippingSearchParamKey} from "features/shipping/types";
import {LoadingSpinner} from "shared/assets/svgs/LoadingSpinner";
import {useCsvCheckboxFilter} from "features/shipping/hooks/useCsvCheckboxFilter";

interface Props {
  value?: string | null
}

const DEFAULT_FILTER = {ordering: "-round"};
export const SellerBatchFilter = ({value}: Props) => {
  const {t} = useTranslation(["shipping"]);
  const {
    checkAll,
    handleChangeChecked,
    handleCheckAll,
    isLoading,
    listData,
    options,
    selectedValues,
  } = useCsvCheckboxFilter<SellerBatchType>({
    fetchParams: DEFAULT_FILTER,
    queryKey: ShippingSearchParamKey.pickupBatchUuids,
    url: queries.batches,
    value,
    toOption: (batch) => ({
      label: `${batch.seller_name} ${batch.round}(${batch.return_count + batch.shipping_count})`,
      value: batch.uuid,
      className: "item",
    }),
    toValue: (batch) => batch.uuid,
  });
  
  return (<div className={"column"}>
    <div className={"filter-title"}>
      <span>{t("batch")}</span>
      <Checkbox rootClassName={"checkAll"} onChange={(event) => handleCheckAll(event.target.checked)}
                checked={checkAll}>
        {t("all")}
      </Checkbox>
    </div>
    <Checkbox.Group
      className={"check-group"}
      value={selectedValues}
      options={options}
      onChange={handleChangeChecked}
    >
      {!listData?.length ? (isLoading ? <LoadingSpinner /> : <span
        className={"nodata"}>데이터가 없습니다</span>) : null}
    </Checkbox.Group>
  </div>);
};
